/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from '~/lib/utils'
import { ClientOnly } from 'remix-utils/client-only'
import { CarouselContent, CarouselItem } from '~/components/UI/shadcn/carousel'

import { Cards } from '~/components/Helpers/CardLoader'
import CarouselContainer from '../helpers/CarouselContainer'
import { useQuery } from '@tanstack/react-query'
import { getEntriesByIds } from '~/lib/contensis/misc'
import Loader from '~/components/UI/General/Loader/Loader'
// import { NewsCardProps } from '~/components/Cards/NewsEvents/NewsCard/NewsCard'

const StandardCarousel = ({
  content,
  cardColour,
  layoutColour,
  // layoutStyle,
  // layoutPosition,
  className,
  skipHydration = false
}: CarouselProps) => {
  const {
    loop,
    autoplay,
    backgroundColour,
    controlsColour,
    showFeatured = false
  } = content

  const foregroundColour =
    layoutColour === 'ink-blue' || layoutColour === 'mid-blue'
      ? 'white'
      : 'ink-blue'

  const cardIds = Array.isArray(content.cards)
    ? content.cards.map((card: any) => card?.sys?.id).filter(Boolean)
    : []

  const { data, isLoading, error } = useQuery({
    queryKey: ['carousel-cards', cardIds],
    queryFn: async () => {
      const result = await getEntriesByIds(cardIds)
      return result
    },
    enabled: !skipHydration && cardIds.length > 0
  })

  const dataById = Array.isArray(data)
    ? data.reduce((acc: Record<string, any>, entry: any) => {
        acc[entry?.sys?.id] = entry
        return acc
      }, {})
    : {}

  const hydratedCards =
    !skipHydration && Array.isArray(content.cards) && Array.isArray(data)
      ? content.cards.map((card: any) =>
          card?.sys?.id ? { ...card, ...dataById[card.sys.id] } : card
        )
      : content.cards

  const cards =
    content.sys?.contentTypeId === 'carouselCaseStudy'
      ? hydratedCards?.map((cs: any) => {
          return {
            heading: cs?.seoStandard?.title,
            description: cs?.description,
            categories: [
              {
                data: {
                  taxonomy: cs?.status,
                  label: cs?.status?.entryTitle,
                  backgroundColour:
                    cs?.status?.entryTitle === 'Complete'
                      ? 'light-aqua'
                      : 'light-orange',
                  showIcon: false
                }
              }
            ],
            sys: {
              contentTypeId: 'pageCaseStudyResearch',
              uri: cs?.sys?.uri
            },
            featured: cs?.showFeatured,
            entryTitle: cs?.seoStandard?.title,
            image:
              cs?.heroStandardAvantGarde &&
              cs?.heroStandardAvantGarde[0]?.image,
            backgroundColour: backgroundColour,
            showDescription: true
          }
        })
      : hydratedCards?.map((card: any, index: Index) => {
          if (card.sys?.contentTypeId === 'pageNewsArticle') {
            return {
              heading: card.heading,
              date: card.date,
              description: showFeatured && index === 0 ? card.description : '',
              categories:
                Array.isArray(card.categories) && card.categories[0]
                  ? [card.categories[0]]
                  : [],
              sys: {
                contentTypeId: 'pageNewsArticle',
                uri: card.sys?.uri
              },
              featured: showFeatured && index === 0 ? true : false,
              entryTitle: card.entryTitle,
              image: card.image,
              backgroundColour: foregroundColour,
              showDescription: true
            }
          }
          // if (card.sys?.contentTypeId === 'pageCaseStudyResearch') {
          //   return {
          //     heading: card.seoStandard.title,
          //     description: card.description,
          //     categories: [
          //       {
          //         data: {
          //           taxonomy: card.status,
          //           label: card.status.entryTitle,
          //           backgroundColour:
          //             card.status.entryTitle === 'Complete'
          //               ? 'light-aqua'
          //               : 'light-orange',
          //           showIcon: false
          //         }
          //       }
          //     ],
          //     sys: {
          //       contentTypeId: 'pageCaseStudyResearch',
          //       uri: card.sys.uri
          //     },
          //     featured: showFeatured && index === 0 ? true : false,
          //     entryTitle: card.seoStandard.title,
          //     image: card.heroStandardAvantGarde[0].image,
          //     backgroundColour: foregroundColour,
          //     showDescription: true
          //   }
          // }
          return card
        })

  if (isLoading)
    return (
      <div className='py-l flex w-full justify-center'>
        <Loader fill={'#f5b6dc'} />
      </div>
    )
  if (error) return <div>Error loading component.</div>

  return (
    <ClientOnly>
      {() => (
        <div className='space-y-m [&_p]:not(.tag):text-base-sm'>
          {cards && (
            <CarouselContainer
              className={cn(
                'space-y-m'
                // layoutStyle === 'whole'
                //   ? '[&>div]:overflow-visible'
                //   : layoutStyle === 'halves' ||
                //       layoutStyle === 'twothirds' ||
                //       layoutStyle === 'onethird' ||
                //       layoutStyle === 'thirds'
                //     ? layoutPosition === 0
                //       ? '[&>div]:overflow-visible [&>div]:[clip-path:inset(-100vw__0-100vw_-100vw)]'
                //       : layoutStyle === 'thirds' && layoutPosition === 1
                //         ? ''
                //         : '[&>div]:overflow-visible [&>div]:[clip-path:inset(-100vw_-100vw_-100vw_0)]'
                //     : ''
              )}
              options={{ loop, autoplay, align: 'start' }}
              controlsColour={
                controlsColour === layoutColour
                  ? foregroundColour
                  : controlsColour
              }
              hideControls={cards.length < 2 ? true : false}
              controlsClasses='lg:ml-m sm:ml-s ml-xs-plus'
            >
              <CarouselContent>
                {cards.map((item, index: Index) => (
                  <CarouselItem
                    key={index}
                    className={cn(
                      '[&>div,&>a]:max-h-[325px] sm:[&>div,&>a]:max-h-[345px] lg:[&>div,&>a]:max-h-[365px]',
                      item.featured
                        ? 'max-w-[636px]'
                        : 'max-w-[275px] sm:max-w-[290px] lg:max-w-[326px]',
                      className
                    )}
                  >
                    <Cards
                      content={{
                        ...item,
                        backgroundColour: cardColour || item.backgroundColour
                      }}
                      carousel={true}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
            </CarouselContainer>
          )}
        </div>
      )}
    </ClientOnly>
  )
}

export default StandardCarousel
